import { render, staticRenderFns } from "./Evaluaciones.vue?vue&type=template&id=b59dc320&"
import script from "./Evaluaciones.vue?vue&type=script&lang=js&"
export * from "./Evaluaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QTable,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QSpace,QBtn,QTable,QTd})
